import React from 'react';

import './index.scss';

// import Attention from 'assets/icon_attention.svg';
import {ReactComponent as Attention} from 'assets/icon_attention.svg';
import CrossIcon from 'components/atoms/Icon/CrossIcon';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import NextButton from 'components/atoms/Button/NextButton';

const PcModalConfirm = ({
  modalIsOpen,
  cancelButton,
  nextButton,
  onClickCloseButton,
}) => {
  if (modalIsOpen) {
    return (
      <div className="PMC-overlay" onClick={onClickCloseButton}>
        <div className="PMC-content" onClick={(e) => e.stopPropagation()}>
          <div className="PMC-wrapper">
            <div className="PMC-information">
              <div className="PMC-img">
                {/* <img className="" src={Attention} alt=""/> */}
                <Attention/>
              </div>
              <div className="PMC-text">
                前のページへ戻りますか？<br/>
                入力内容は削除されます
              </div>
            </div>
            <div className="PMC-button-area">
              <div className="PMC-cancel-button">
                <ClickOnlyButton label={cancelButton.label} onClick={cancelButton.onClick} color='white' valid />
              </div>
              <div className="PMC-next-button">
                <NextButton label={nextButton.label} onClick={nextButton.onClick} link = {nextButton.link} valid/>
              </div>
            </div>
            <button className="PMC-close-button" type="button" onClick={onClickCloseButton}><CrossIcon /></button>
          </div>
        </div>
      </div>
    );
  }
  return null;


};

export default PcModalConfirm;